module.exports = __webpack_public_path__ + "img/barion-card-strip-intl.75f457c.svg";